import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=0d0edaa1&"
import script from "./search-box.vue?vue&type=script&lang=ts&"
export * from "./search-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports